export default __webpack_public_path__ + "static/media/ml.917ee3c8.svg";